__turbopack_context__.v({
  "className": "latolatinext_a04010cd-module__E65c6G__className",
  "variable": "latolatinext_a04010cd-module__E65c6G__variable",
});
